import { CountryCode } from 'libphonenumber-js';

export class AppSettings {
    static phoneCountryCode: CountryCode = 'GB';
    retailerPrivacyPolicyUrl: string;
    retailerTermsAndConditions: string;
    retailerBookingFormUrl: string;
    retailerContactUsPageUrl: string;
    retailerAddress: string;
    retailerConfirmationAddress: string;
    retailerName: string;
    retailerEmailAddress: string;
    retailerSalesTelephoneNumber: string;
    retailerId: string;
    retailerRttdThankyouPageUrl: string;
    policyId: string;
    policyVersion: string;
    externalReferenceId: string;
    nationalPrivacyPolicyUrl: string;
    realtimeEndpointUrl: string;
    contentRootUrl: string;
    offSiteLocationCopy: string;
    allowOffSite: boolean;
    apiHostUrl: string;
    satelliteRetailerCode?: string;
    sharedAssetsUrl:string;
    eventJourney: boolean;
    eventName: string;
    eventConfirmationModelSelection: string;
    eventAllowGuests: boolean;
    eventModelTreeRef: string;

    apiBrand: string;

    modelFilter: string;
    rescheduleId: string;

    overridePdiImport: string;
    overridePdiSource: string;
}
